(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  const popup = document.getElementById('HcxWelcomePopup');
  if (!popup || typeof popup.showModal !== 'function') return;
  const seenKey = 'hcx-welcome-seen-v2';
  const pendingKey = 'hcx-welcome-pending-v2';
  const preview = new URLSearchParams(window.location.search).get('welcome-preview') === '1';
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch (_) { return null; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, value); } catch (_) {} };
  const remove = (storage, key) => { try { window[storage].removeItem(key); } catch (_) {} };
  const hasSeen = () => read('localStorage', seenKey) || read('sessionStorage', seenKey);
  const remember = () => {
    if (preview) return;
    write('localStorage', seenKey, '1');
    write('sessionStorage', seenKey, '1');
  };
  let previousFocus;
  let previousOverflow;
  let previousRootOverflow;
  let dismissed = false;
  let timer;
  const open = () => {
    if (popup.open || dismissed) return;
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    previousRootOverflow = document.documentElement.style.overflow;
    popup.showModal();
    popup.focus({ preventScroll: true });
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    remember();
  };
  const restorePage = () => {
    dismissed = true;
    window.clearTimeout(timer);
    remember();
    document.body.style.overflow = previousOverflow || '';
    document.documentElement.style.overflow = previousRootOverflow || '';
    if (previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
  };
  const close = () => {
    if (!popup.open) return;
    popup.close();
    restorePage();
  };
  popup.addEventListener('close', restorePage);
  popup.addEventListener('cancel', event => { event.preventDefault(); close(); });
  popup.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', close));
  const outside = event => {
    const bounds = popup.getBoundingClientRect();
    return event.target === popup && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
  };
  let backdropPointer = false;
  popup.addEventListener('pointerdown', event => { backdropPointer = outside(event); });
  popup.addEventListener('click', event => {
    if (backdropPointer && outside(event)) close();
    backdropPointer = false;
  });
  const form = popup.querySelector('form');
  form.addEventListener('submit', () => {
    write('sessionStorage', pendingKey, '1');
    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;
  });
  const pending = read('sessionStorage', pendingKey);
  const success = popup.querySelector('[data-welcome-success]');
  const error = popup.querySelector('[data-welcome-error]');
  if (pending && (success || error)) {
    remove('sessionStorage', pendingKey);
    open();
    return;
  }
  if (success) { remember(); return; }
  if (hasSeen() && !preview) return;
  const visible = element => {
    const bounds = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return element.getAttribute('aria-hidden') !== 'true' && bounds.width > 0 && bounds.height > 0 &&
      bounds.right > 0 && bounds.left < window.innerWidth && bounds.bottom > 0 && bounds.top < window.innerHeight &&
      style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0';
  };
  const showWhenReady = () => {
    if (dismissed || (hasSeen() && !preview)) return;
    const otherModal = Array.from(document.querySelectorAll('dialog[open], cart-drawer.active, details[open].menu-opening, [role="dialog"][aria-modal="true"]'))
      .some(element => element !== popup && visible(element));
    const typing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
    if (document.visibilityState === 'hidden' || otherModal || typing) {
      timer = window.setTimeout(showWhenReady, 1000);
      return;
    }
    open();
  };
  timer = window.setTimeout(showWhenReady, Number(popup.dataset.welcomeDelayMs) || 15000);
})();
